import { FC } from 'react';
import './date-interval-select.scss';
import DateIntervalSelectItem from './DateIntervalSelectItem';
import { DATE_INTERVALS } from '../constants';
import IDateIntervalSelect from '../models/date-interval-select.props';

const DateIntervalSelect: FC<IDateIntervalSelect> = ({ onSelect, initialValue }) => {

  const handleItemClick = (value: string) => {
    onSelect(value);
  };

  return (
    <ul className="date-interval-select">
      {
        DATE_INTERVALS.map(({ label, value, icon }, index) =>
          <DateIntervalSelectItem
            key={label}
            label={label}
            value={value}
            icon={icon}
            first={index === 0}
            last={index === DATE_INTERVALS.length - 1}
            active={initialValue === value}
            onItemClick={handleItemClick}
          />
        )
      }
    </ul>
  );
};

export default DateIntervalSelect;